import { useCourseTracking } from '../hooks/use-course-tracking'

export default function CourseTracker() {
  useCourseTracking()
  return <></>
}
